@if (show) {
    <div @fadeIn @fadeOut class="loading-overlay">
        <div class="spinner-container">
            <!-- Aro de carga en SVG -->
            <img src="images\loading\loading.svg" alt="Cargando..." class="spinner">
            <!-- Logo PNG -->
            <img src="images\logo\logo-ave-cut.png" alt="AVE" class="logo">
        </div>
    </div>
}
